// When auto scrolling to the bottom of the page,
// if the last message group height is not reduced by this amount, the message bubble will be cut off by the header
const SCROLL_TO_VIEW_MARGIN = 16;

export const getLastMessageGroupMinHeight = (containerHeight: number): number =>
	containerHeight - SCROLL_TO_VIEW_MARGIN;
